module.exports = __webpack_public_path__ + "static/think-like-a-monk-0bea07d0eb3f226f74378957a4619bd7.webp";